import React from "react";
import useFooter from "../../hooks/useFooter";

import IconMakeNote from "../../images/icn-make-note.png";
import BrandingFooter from "../Footer/BrandingFooter";
import Spinner from "../Spinner";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { setNote } from "../../store/slices/assessment";

function NoteSlide({ setAssessment, isVisible, onSubmit }) {
  const dispatch = useDispatch();
  const { isSubmitting } = useSelector((state) => state.assessment);

  useFooter(isVisible, <BrandingFooter />);

  return (
    <div className="h-full bg-how-feeling">
      <div className="block-emotti ">
        <div className="block-welcome">
          <img src={IconMakeNote} alt="" className="emotii-ttl" />

          <div className="text-right border-heading">
            <h1 className="">Make a Note</h1>
          </div>

          <div className="">
            <p className="text-lg leading-[22px]">
              Before we show your results, are there any changes in your life
              that might be caused by - or related to - how you’ve been feeling?
              <br />
              <br />
              If so, jot down a few notes here so you can refer to this
              information later. It can be super helpful as you track your
              feelings over time:
            </p>

            <div>
              <label className="block">
                <textarea
                  className="text-area text-black"
                  rows="7"
                  placeholder="Enter your note here (optional) "
                  onChange={(e) => {
                    dispatch(setNote(e.target.value));
                  }}
                />
              </label>
            </div>

            <div className="btn-box-introduction">
              <a
                href="#"
                className={classNames("btn btn-white btn btn-gray", {
                  "pointer-events-none opacity-50": isSubmitting,
                })}
                onClick={onSubmit}
              >
                <div className="flex justify-around items-center">
                  View my Results
                  {isSubmitting && <Spinner dark />}
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoteSlide;
